
// ST Product descreption remove &nbsp
document.querySelectorAll('.product__info-wrapper, .blog-articles__article .card__content .card__information p, .article-template__content p').forEach(el => {
  el.innerHTML = el.innerHTML.replace(/&nbsp;/g, '');
});
document.querySelectorAll('.product__description.rte .panelProduct ul li')
  .forEach(li => {
    if (li.textContent.trim() === '') {
      li.classList.add('empty');
    }
  });

// empty newsletter form footer
document.querySelectorAll('.footer-block--newsletter').forEach(function(el) {
  if (el.textContent.trim() === '') {
    el.style.display = 'none';
  }
});






// header toggle button for menu
document.addEventListener('DOMContentLoaded', function () {
  var menuButton = document.querySelector('.header__icon--menu');
  var menuIcon   = document.querySelector('.menu-icon');
  var overlay    = document.querySelector('.custom-menu-drawer-overlay');
  var drawer     = document.querySelector('.custom-menu-drawer');
  var closeBtn   = document.getElementById('custom-menu-close');

  if (!menuButton || !menuIcon || !overlay || !drawer || !closeBtn) {
    console.warn('One or more elements not found.');
    return;
  }

  // --- Reset everything to initial state ---
  function resetMenu() {
    menuIcon.style.display = 'block';
    closeBtn.style.display = 'none';

    menuIcon.classList.remove('menu-open');
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    closeBtn.classList.remove('is-visible');
  }

  // Call once on page load
  resetMenu();

  // --- Open menu ---
  menuButton.addEventListener('click', function () {
    menuIcon.classList.add('menu-open');
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    closeBtn.classList.add('is-visible');

    // switch buttons
    menuIcon.style.display = 'none';
    closeBtn.style.display = 'block';
  });

  // --- Close menu ---
  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    resetMenu();
  });

  overlay.addEventListener('click', resetMenu);
});


document.addEventListener('DOMContentLoaded', function() {
  // Find FAQ text and add class to the same element
  document.querySelectorAll(
    '.article-template p b, .article-template b, .article-template h1, .article-template h2, .article-template h3, .article-template h4, .article-template h5, .article-template h6'
  ).forEach(el => {
    const text = el.textContent.trim().toLowerCase();
    if (text === 'faq' || text === 'faqs') {
      // Add class directly to this element
      el.classList.add('faq-found');
      // Change text to "FAQs"
      el.textContent = 'FAQs';
    }
  });

  // Accordion functionality
  document.querySelectorAll('.accordion').forEach(function(btn) {
    btn.addEventListener('click', function() {
      this.classList.toggle('active');
      var panel = this.parentElement.nextElementSibling;
      var panelNoParent = this.nextElementSibling;

      if (panel) panel.classList.toggle('open');
      if (panelNoParent) panelNoParent.classList.toggle('open');
    });
  });
});



// document.addEventListener('DOMContentLoaded', function () {
//   const article = document.querySelector('.article-template__content');
//   if (!article) return;

//   const allImages = article.querySelectorAll('img');
//   const textOnly = article.cloneNode(true);
//   textOnly.querySelectorAll('img').forEach(img => img.remove());

//   const wrapper = document.createElement('div');
//   wrapper.className = 'two-column-layout article-template__content page-width rte';
//   const left = document.createElement('div');
//   left.className = 'article-left';
//   const right = document.createElement('div');
//   right.className = 'article-right';

//   left.innerHTML = textOnly.innerHTML;
//   allImages.forEach(img => right.appendChild(img.cloneNode(true)));

//   wrapper.appendChild(left);
//   wrapper.appendChild(right);
//   article.replaceWith(wrapper);
// });






// document.addEventListener('DOMContentLoaded', function () {
//   const article = document.querySelector('.article-template__content');
//   if (!article) return;

//   const textOnly = article.cloneNode(true);
//   const imageBlocks = [];

//   article.querySelectorAll('img').forEach(img => {
//     let blockToMove = null;

//     const directParent = img.parentElement;

//     if (directParent && directParent.tagName.toLowerCase() === 'a') {
//       // Case 1: Direct parent is <a>
//       blockToMove = directParent;
//     } else {
//       // Check if the img is wrapped somewhere in an <a>
//       const wrappedLink = img.closest('a');
//       if (wrappedLink) {
//         blockToMove = wrappedLink;
//       } else if (directParent && directParent.tagName.toLowerCase() === 'p') {
//         // No <a>, but parent is <p>
//         blockToMove = directParent;
//       } else {
//         // Standalone image
//         blockToMove = img;
//       }
//     }

//     if (blockToMove && !imageBlocks.includes(blockToMove)) {
//       imageBlocks.push(blockToMove);
//     }
//   });

//   // Remove extracted blocks from text version
//   textOnly.querySelectorAll('img').forEach(img => {
//     const directParent = img.parentElement;
//     const wrappedLink = img.closest('a');

//     if (directParent && directParent.tagName.toLowerCase() === 'a') directParent.remove();
//     else if (wrappedLink) wrappedLink.remove();
//     else if (directParent && directParent.tagName.toLowerCase() === 'p') directParent.remove();
//     else img.remove();
//   });

//   // Build new layout
//   const wrapper = document.createElement('div');
//   wrapper.className = 'two-column-layout article-template__content page-width rte';

//   const left = document.createElement('div');
//   left.className = 'article-left';
//   left.innerHTML = textOnly.innerHTML;

//   const right = document.createElement('div');
//   right.className = 'article-right';

//   imageBlocks.forEach(block => right.appendChild(block.cloneNode(true)));

//   wrapper.appendChild(left);
//   wrapper.appendChild(right);

//   article.replaceWith(wrapper);
// });






// Header Js for Home & about Us When open mega menu Start
const menuToggles = document.querySelectorAll('.mega-menu');
let lastClickedMenu = null;

if (menuToggles.length > 0) {
  menuToggles.forEach(menu => {
    const trigger = menu.querySelector('.header__menu-item');

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();

        if (lastClickedMenu === menu && document.body.classList.contains('wrapper__list__open')) {
          document.body.classList.remove('wrapper__list__open');
          lastClickedMenu = null;
        } else {
          document.body.classList.add('wrapper__list__open');
          lastClickedMenu = menu;
        }
      });
    }
  });

  document.addEventListener('click', function (e) {
    const isInsideMenu = e.target.closest('.mega-menu');
    const isInsideContent = e.target.closest('.mega-menu__content');

    if (!isInsideMenu && !isInsideContent) {
      document.body.classList.remove('wrapper__list__open');
      lastClickedMenu = null;
    }
  });
}

// Header Js for Home & about Us When open mega menu End



// New Store Location JS Start 10-11-2025


         const defaultBox = document.querySelector('.wrapper__store__defult');
        const previewBox = document.querySelector('.wrapper__sitl__box__image');
        const storeBoxes = document.querySelectorAll('.wrapper__sitl__box');

        storeBoxes.forEach(box => {
            box.addEventListener('mouseenter', () => {
                const imgSrc = box.getAttribute('data-img');
                if (imgSrc) {
                    // Remove any existing preview image
                    previewBox.innerHTML = '';

                    // Create new image element
                    const img = document.createElement('img');
                    img.src = imgSrc;
                    img.alt = 'preview image';
                    img.className = 'img-fluid';

                    previewBox.appendChild(img);
                    previewBox.style.display = 'block';
                    defaultBox.style.display = 'none';
                }
            });

            box.addEventListener('mouseleave', () => {
                // Check if hovering any .wrapper__sitl__box
                setTimeout(() => {
                    const isHoveringAny = Array.from(storeBoxes).some(el =>
                        el.matches(':hover')
                    );
                    if (!isHoveringAny) {
                        previewBox.innerHTML = '';
                        previewBox.style.display = 'none';
                        defaultBox.style.display = 'block';
                    }
                }, 10);
            });
        });


         document.addEventListener('DOMContentLoaded', () => {
            const form = document.querySelector('.wrapper__store__sb form');
            const input = document.querySelector('#search');
            const tabs = document.querySelectorAll('.wrapper__sth');
            const headings = document.querySelectorAll('.wrapper__store__tab__heading');
            const noRecord = document.querySelector('.no-record');

            const resetTabs = () => {
                tabs.forEach(tab => {
                    tab.classList.remove('active');
                    tab.querySelector('.wrapper__store__tab__content')?.style.setProperty('max-height', null);
                });
            };

            const openTab = tab => {
                resetTabs();
                tab.classList.add('active');
                const content = tab.querySelector('.wrapper__store__tab__content');
                if (content) content.style.maxHeight = content.scrollHeight + 'px';
            };

            const filterTabs = q => {
                const query = q.trim().toLowerCase();
                let firstMatch = null;
                let matchCount = 0;

                tabs.forEach(tab => {
                    const heading = tab.querySelector('h2')?.textContent.toLowerCase() || '';
                    const content = tab.querySelector('.wrapper__store__tab__content')?.textContent.toLowerCase() || '';
                    const match = heading.includes(query) || content.includes(query);
                    tab.style.display = match ? '' : 'none';
                    if (match) matchCount++;
                    if (match && !firstMatch) firstMatch = tab;
                });

                noRecord.style.display = matchCount ? 'none' : 'block';
                if (firstMatch) openTab(firstMatch);
            };

            form?.addEventListener('submit', e => {
                e.preventDefault();
                filterTabs(input?.value || '');
            });

            input?.addEventListener('input', () => {
                if (!input.value.trim()) {
                    tabs.forEach(tab => {
                        tab.style.display = '';
                        tab.classList.remove('active');
                        tab.querySelector('.wrapper__store__tab__content')?.style.setProperty('max-height', null);
                    });
                    noRecord.style.display = 'none';
                }
            });

            headings.forEach(h => {
                h.addEventListener('click', () => {
                    const tab = h.closest('.wrapper__sth');
                    if (!tab) return;
                    tab.classList.contains('active') ? resetTabs() : openTab(tab);
                });
            });
        });
// New Store Location JS End  10-11-2025

//  About Us Timeline Up & down JS Start
 const scrollContainer = document.querySelector('.timeline__years__box');
const scrollUpBtn = document.querySelector('.scroll-up');
const scrollDownBtn = document.querySelector('.scroll-down');
const scrollStep = 100; // pixels per click

if (scrollContainer) {
  if (scrollUpBtn) {
    scrollUpBtn.addEventListener('click', () => {
      scrollContainer.scrollBy({ top: -scrollStep, behavior: 'smooth' });
    });
  }

  if (scrollDownBtn) {
    scrollDownBtn.addEventListener('click', () => {
      scrollContainer.scrollBy({ top: scrollStep, behavior: 'smooth' });
    });
  }
}


//  About Us Timeline Up & down JS End

// 24-11-2025 WS
// Select all product media containers (safe for multiple items)
const containers = document.querySelectorAll('.product__media');

if (containers.length) {
  containers.forEach(container => {
    const img = container.querySelector('img');
    if (!img) return; // null-safe

    // Zoom in when entering the container
    container.addEventListener('mouseenter', () => {
      img.style.transform = 'scale(1.8)'; // zoom level
    });

    // Follow mouse position inside the container
    container.addEventListener('mousemove', e => {
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
    });

    // Reset when leaving the container
    container.addEventListener('mouseleave', () => {
      img.style.transformOrigin = 'center center';
      img.style.transform = 'scale(1)';
    });
  });
}
// 24-11-2025 WE



// create product accor 25-11-25 WS
// create product accor 25-11-25 WS
const lang = document.documentElement.lang; // get <html lang="...">

if (lang === 'ja' || lang === 'es') {
  document.querySelectorAll('.js .product__description').forEach(parent => {
    if (!parent) return; // null check

    let children = Array.from(parent.children);
    let buffer = null;

    children.forEach(el => {
      if (el.tagName === 'H3') {
        // skip if H3 already has accordionProduct class
        if (el.classList.contains('accordionProduct')) {
          buffer = null; // reset buffer so we don’t wrap again
          return;
        }

        // flush buffer for previous H3 (if any)
        if (buffer && buffer.length) {
          let panel = document.createElement('div');
          panel.className = 'panelProduct';
          buffer.forEach(node => panel.appendChild(node));
          parent.insertBefore(panel, el);
        }

        // mark H3
        el.classList.add('accordionProduct');

        // start new buffer for content after this H3
        buffer = [];
      } else {
        // collect content after the current H3
        if (buffer) buffer.push(el);
      }
    });

    // flush last buffer at the end
    if (buffer && buffer.length) {
      let panel = document.createElement('div');
      panel.className = 'panelProduct';
      buffer.forEach(node => panel.appendChild(node));
      parent.appendChild(panel);
    }
  });
};
// create product accor 25-11-25 WE
// create product accor 25-11-25 WE

//PDP page accordion*
document.querySelectorAll('.accordionProduct').forEach(function(btn) {
  btn.addEventListener('click', function() {
    this.classList.toggle('active');
    var panelProduct = this.parentElement.nextElementSibling;
    var panelNoParentProduct = this.nextElementSibling;
    panelProduct.classList.toggle('open');
    panelNoParentProduct.classList.toggle('open');
  });
});

// document.getElementById('blog-selector').addEventListener('change', function() {
//   var value = this.value;
//   console.log("selected value",value);
//   if (value) {
//     window.location.href = value;
//   }
// });


// 24-11-25 Js comment 
// document.addEventListener('DOMContentLoaded', function () {
//   const tagList = document.getElementById('blog-tag-filter');
//   tagList.addEventListener('click', function (e) {
//     const target = e.target.closest('li');
//     if (target && target.dataset.url) {
//       const value = target.dataset.url;
//       console.log("selected value", value);
//       window.location.href = value;
//     }
//   });
// });

// 24-11-25 Js updated
document.addEventListener('DOMContentLoaded', function () {
  const tagList = document.getElementById('blog-tag-filter');
  if (!tagList) return; // Safeguard against missing element

  tagList.addEventListener('click', function (e) {
    const target = e.target.closest('li');
    if (target && target.dataset.url) {
      const value = target.dataset.url;
      console.log("selected value", value);
      window.location.href = value;
    }
  });
});

// 24-11-25 Js End


// 13-01-2026 WS
document.addEventListener("DOMContentLoaded", function () {
  function toggleHeaderSticky() {
    if (window.scrollY > 50) {
      document.querySelector(".header-wrapper").classList.add("headerSticky");
    } else {
      document.querySelector(".header-wrapper").classList.remove("headerSticky");
    }
  }

  // Check scroll position on page load
  toggleHeaderSticky();

  // Check scroll position on scroll
  window.addEventListener("scroll", toggleHeaderSticky);
});
// 13-01-2026 WE


document.addEventListener("DOMContentLoaded", function () {
  var blogList = document.querySelector(".wrapper__blogs__list ul");
  var btnUp = document.getElementById("scrollUp");
  var btnDown = document.getElementById("scrollDown");

  if (blogList && btnUp && btnDown) {
    // Ensure div is scrollable
    blogList.style.overflowY = "auto";
    blogList.style.height = "560px";

    btnUp.addEventListener("click", function () {
      blogList.scrollBy({ top: -100, behavior: "smooth" });
    });

    btnDown.addEventListener("click", function () {
      blogList.scrollBy({ top: 100, behavior: "smooth" });
    });
  }
});